import { useMemo } from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { UserData } from '../../types';

const COLORS = ['#3b82f6', '#f59e0b'];

interface BillingChartProps {
  users: UserData[];
}

export function BillingChart({ users }: BillingChartProps) {
  const data = useMemo(() => {
    let monthly = 0;
    let annual = 0;
    users.forEach(u => {
      if (!u.subscribed) return;
      if (u.billingInterval === 'year') annual++;
      else monthly++;
    });
    return [
      { name: 'Monthly', value: monthly },
      { name: 'Annual', value: annual },
    ].filter(d => d.value > 0);
  }, [users]);

  const renderLabel = ({ name, percent }: { name: string; percent: number }) =>
    `${name} ${(percent * 100).toFixed(0)}%`;

  return (
    <div className="chart-card">
      <h3>Billing Interval</h3>
      <ResponsiveContainer width="100%" height={250}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={renderLabel}>
            {data.map((_, i) => (
              <Cell key={i} fill={COLORS[i % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
